export class ServerError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
